<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n2">
        Which of the following is an appropriate piece of eye protection for general chemistry labs?
      </p>

      <v-radio-group v-model="inputs.input1" class="ml-6 mb-0" :disabled="!allowEditing">
        <v-radio
          v-for="option in optionsShuffled"
          :key="option.value"
          class="my-n2"
          :value="option.value"
        >
          <template #label>
            <v-img :src="option.img" style="max-width: 183px" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'ChemMcMPL3Q4',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
      options: [
        {img: prefixPublicAsset('/img/assignments/McM-PL3-Q4_optionA.png'), value: 'a'},
        {img: prefixPublicAsset('/img/assignments/McM-PL3-Q4_optionB.png'), value: 'b'},
        {img: prefixPublicAsset('/img/assignments/McM-PL3-Q4_optionC.png'), value: 'c'},
        {img: prefixPublicAsset('/img/assignments/McM-PL3-Q4_optionD.png'), value: 'd'},
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
  },
};
</script>
